/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".included-per-passenger--item[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{padding:2rem 0}@media (max-width:599px){.included-per-passenger--item[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{padding:1rem 0}.included-per-passenger--label[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{padding-left:0;padding-top:0}}"];
export { styles as styles };
